module.exports = __webpack_public_path__ + "media/images/bgr-lw-274001a317aa2fb5ad56e96a8b23648c.jpg";